'use client';
import { useEffect, useState } from 'react';
import { Flex, Text, Title } from '@gjensidige/builders-components';
import { Search } from '../shared/search';
import type { SearchProps } from '../shared/types';
import styles from './page-search.module.less';

export const PageSearch = (props: SearchProps) => {
  const [query, setQuery] = useState('');

  useEffect(() => {
    setQuery(new URLSearchParams(window.location.search).get('q') || '');
  }, []);

  return (
    <Flex
      center
      className={styles.marginBHeaders}
      gap="md xl"
      layout={{ xs: 1, md: 2 }}
    >
      <div className={styles.searchPageTextContent}>
        <div>
          <Title as="h1" size="3" text={props?.phrases?.information?.title} />
          <Text size="lead">{props?.phrases?.information?.text}</Text>
        </div>
      </div>
      <Search
        {...props}
        phrases={{ ...props.phrases, information: {} }}
        query={query}
      />
    </Flex>
  );
};
